<template>
    <div class="loading-wrapper">
        <p>loading...</p>
    </div>
</template>

<script>
export default {
    name: 'rc-loading'
}
</script>

<style scoped>
.loading-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(255, 255, 255, .5);

    display: flex;
    justify-content: center;
    align-items: center;
}
</style>